import { RootState } from '@/store/types';
import { CoursesState } from '@/store/courses/types';
import axios from 'axios';
import { Commit, ActionTree } from 'vuex';

const actions: ActionTree<CoursesState, RootState> = {
  importCoursesByCsv: (context, csvFile: File) => {
    const formData = new FormData();
    formData.append('csv', csvFile);
    return axios.post('/courses/import', formData);
  },
};

export default actions;
